/* eslint-disable @typescript-eslint/ban-types */
import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import { ProductData } from '@ikea-aoa/component-view-3d';
import { RangeSettings, SceneHelperData } from 'sofa-reborn-react';

const SceneHelperContainer: FC = () => {
	const sceneHelper = useSelector<RootState, SceneHelperData>(
		(state) => state.scene.sceneHelper as SceneHelperData
	);

	const products = useSelector<RootState, ProductData>((state) => state.products.products);

	const rangeSettings = useSelector<RootState, RangeSettings>(
		(state) => state.settings.rangeSettings as RangeSettings
	);

	const getPosition = (): {} => {
		const position = sceneHelper ? sceneHelper.pos : { x: 0, y: 0 };
		return {
			width: '110px',
			height: '110px',
			position: 'absolute',
			top: position.y - 55 + 'px',
			left: position.x - 55 + 'px',
		};
	};

	const getSrc = (): string => {
		const id = sceneHelper && sceneHelper.id;
		const product =
			products && id && Object.values(products).find((product) => product.productId === id);

		const modelId = product && product.modelId;
		const colorId = product && product.filter.color;
		const imgSrc = colorId
			? rangeSettings.thumbnailsSrc + '/' + modelId + '_' + colorId.toUpperCase() + '.png'
			: '';
		return imgSrc;
	};

	return (
		<div style={getPosition()}>
			<img src={getSrc()} style={{ height: '-webkit-fill-available' }}></img>
		</div>
	);
};

export default SceneHelperContainer;
